import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CarrierLink from './CarrierLink';
import { NormalText } from '../StyledComponents';
import Image from '../Image';
import Link from '../Link';

import './Carrier.module.scss';

class Carrier extends React.PureComponent {
  render() {
    const {
      isMobile: mobile,
      name,
      logoUrl,
      trackingUrl,
      trackingCode,
      showLogo,
      showLink,
      showTrackingCode,
      carrierLinkLabel,
      carrierTrackingCodeLabel,
      designSettings: {
        bodyFontSize,
        bodyFont,
        carrierBackgroundColor,
        carrierTextColor,
        carrierTextLinkColor,
        carrierTextLinkHoverColor,
      },
    } = this.props;

    const styleName = classNames('carrier', { mobile });

    if (!showLogo && !showLink && !showTrackingCode) {
      return null;
    }

    return (
      <div styleName="carrier-wrapper" style={{ backgroundColor: carrierBackgroundColor }}>
        <div styleName={styleName}>
          {showLogo && (
            <Link href={trackingUrl}>
              <Image src={logoUrl} styleName="logo" name={name} />
            </Link>
          )}
          {showLink && (
            <div styleName="description">
              <NormalText
                type="bodySecondary"
                isMobile={mobile}
                color={carrierTextColor}
                fontSize={bodyFontSize}
                font={bodyFont}
              >
                {carrierLinkLabel}&nbsp;
                <CarrierLink
                  trackingUrl={trackingUrl}
                  color={carrierTextLinkColor}
                  hoverColor={carrierTextLinkHoverColor}
                >
                  {name}
                </CarrierLink>
              </NormalText>
            </div>
          )}
          {showTrackingCode && (
            <div styleName="tracking-code">
              <NormalText
                type="bodyTertiary"
                isMobile={mobile}
                color={carrierTextColor}
                fontSize={bodyFontSize}
                font={bodyFont}
              >
                {carrierTrackingCodeLabel}&nbsp;
                <CarrierLink
                  trackingUrl={trackingUrl}
                  color={carrierTextLinkColor}
                  hoverColor={carrierTextLinkHoverColor}
                >
                  {trackingCode}
                </CarrierLink>
              </NormalText>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Carrier.propTypes = {
  isMobile: PropTypes.bool,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  trackingUrl: PropTypes.string,
  trackingCode: PropTypes.string,
  showLogo: PropTypes.bool,
  showLink: PropTypes.bool,
  showTrackingCode: PropTypes.bool,
  designSettings: PropTypes.shape({
    bodyFontSize: PropTypes.string,
    bodyFont: PropTypes.string,
    bodyTextLinksColor: PropTypes.string,
    bodyTextColor: PropTypes.string,
    bodyTextLinksHoverColor: PropTypes.string,
  }),
  carrierLinkLabel: PropTypes.string,
  carrierTrackingCodeLabel: PropTypes.string,
};

export default Carrier;
